import $ from 'jquery';
import {gsap} from "gsap";
import {init_animation} from "./animation";
const $filters_li = $("ul.filters-tax-list>li");
const $checkboxes_filter = $(".filters-post ul.filters-tax-terms input.form-check-input");
const $rowWrapper = $("#row_posts_wrapper");
const $rowMoreContent = $("#more_content_row");
const $readMoreBtn = $rowMoreContent.find('.diplay_more_content_btn');
const $filter_post = $(".filters-post");
/**
 * Init the Archive page master page
 */
const init_archive_page = () => {
    if($filters_li.length){
       init_drop_down_filter();
    }
    if($readMoreBtn.length){
        $readMoreBtn.on('click', (e) => load_more_content(e))
    }

    // PopState handler (hastory back and forward)
    // même comportement que https://charlieojackson.co.uk/tutor/seo-friendly-pagination/load-more.php
    window.onpopstate = (e) => popStateHandler(e);
};

/**
 * Initialize dropdown filter
 */
const init_drop_down_filter = () => {
    // Pour chaque bouton de filtres on écoute le click pour afficher les boutons radios
    $filters_li.each(function() {
        const btn = $(this).children("button.btn-filter");
        btn.on('click', (e) => click_dropdown_filter_btn(e));
    });

    // Listen checkbox change
    $checkboxes_filter.on('change', (e, data) => click_checkbox_filter(e, data));

    // Listen close filter button click
    $( "#active_filter ul.active-filter-list" ).on( "click", "li button.pushed", (e) => click_remove_filter_button(e));

    // listen erase all button
    $("#erase-all-filters").on('click', () => erase_all_filters_handler());

    // Close open dropdown if click outside
    $(window).on('click', (e) => {
        if (!$(e.target).hasClass("btn-filter") && !$(e.target).hasClass("filters-tax-terms") && !$(e.target).hasClass("filters-tax-terms-wrapper") && !$(e.target).hasClass("form-check") && !$(e.target).hasClass("form-check-input") && !$(e.target).hasClass("form-check-label")) {
            close_existing_dropdown_opened();
        }
    })

    // Close open drop down on escape key pressed
    $(document).on('keyup', function(e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`
            close_existing_dropdown_opened();

        }
    });
}

/**
 * Uncheck all checkbox flters
 */
const erase_all_filters_handler = () => {
    const $filters_checkboxes_active = $checkboxes_filter.filter(":checked"),
        nb_active_filters = $filters_checkboxes_active.length;
    let $el = false;
    $filters_checkboxes_active.each(function (index, el){
        $el = $(el)
        $el.prop( "checked", false );

        // force page refresh only for the last button
        const refresh_page = index >= nb_active_filters -1;
        $el.trigger('change', [{refresh:refresh_page}]);
    })
}

/**
 * Handle déclenché au clic sur un bouton bleu de filtre (pour le supprimer)
 * On regarde le bouton radio correspondant et on le décoche.
 * @param e
 */
const click_remove_filter_button = (e) => {
    const $btn = $(e.currentTarget),
        btn_tax = $btn.data('tax'),
        btn_slug =$btn.data('slug');

    const checkbox_to_uncheck= $checkboxes_filter.filter(function (){
        return $(this).val() === btn_slug && $(this).data('tax') === btn_tax;
    })
    checkbox_to_uncheck.prop( "checked", false );
    checkbox_to_uncheck.trigger('change');

}

/**
 * Click handler for checkbox filter
 * @param e
 * @param data
 */
const click_checkbox_filter = (e, data) => {
    const $cb = $(e.currentTarget),
        cb_tax = $cb.data('tax'),
        cb_slug = $cb.val();
    // Si la checkbox est cochée on l'ajoute au filtre en dessous
    if($cb.is(':checked')){
        const cb_label = $cb.data('label');
        add_active_filter_btn(cb_tax, cb_slug, cb_label);
    }
    // Si la checkbox est décoché on la retire du filtre en dessous
    else{
        remove_active_filter_btn(cb_tax, cb_slug);
    }
    show_hide_filter_box_and_link();


    if(data === undefined || data.refresh){
        // Define page number
        const new_page_number = 1;

        // Push history
        const historyData = build_history_data(new_page_number);
        history.pushState(historyData.stateData, '', historyData.url);
        launch_ajax_query(new_page_number, true);
    }
}

/**
 * Ajoute un bouton de filtre actif (bouton bleu)
 * @param tax
 * @param slug
 * @param label_btn
 */
const add_active_filter_btn = (tax, slug, label_btn) => {
    const $new_li = $(`<li class="list-inline-item mb-1"><button data-tax="${tax}" data-slug="${slug}" class="btn btn-secondary pushed">${label_btn}<span class="icon icon-cross"></span></button></li>`);
    $new_li.insertBefore( $("li#li-erase-all"));
}

/**
 * Supprime un bouton de filtre actif (bouton bleu)
 * @param tax
 * @param slug
 */
const remove_active_filter_btn = (tax, slug) => {
    $('ul.active-filter-list li button.pushed').each(function (index, el){
        if ( $(el).data('tax') === tax && $(el).data('slug') === slug ) {
            const $li_parent = $(el).parent();
            $li_parent.remove();
        }
    })
}

/**
 * Détermine si l'on doit affiche le lien "Effacer tout" et la div contenant les filtres
 */
const show_hide_filter_box_and_link = () => {
    const nb_active_filter = $('ul.active-filter-list li').length - 1;
    if(nb_active_filter <= 1){
        $("li#li-erase-all").addClass("d-none");
    }else{
        $("li#li-erase-all").removeClass("d-none");
    }

    if(nb_active_filter <= 0){
        $("#active_filter").addClass("d-none")
    }else{
        $("#active_filter").removeClass("d-none")
    }
}



/**
 * PopState handler (if we have a previous state, we populate the for with this
 * else, we populate the form with existing query string, thene launch a request
 * @param e
 */
const popStateHandler = (e) => {
    let obj = {}
    if (e.state) {
        // console.log("State existe");
        obj = e.state;
        // uncheck all checkboxes
        $checkboxes_filter.prop("checked", false).blur();
        //remove all active buttons filter
        $( "#active_filter ul.active-filter-list li:not(#li-erase-all)").remove();

        for (const [key, value] of Object.entries(obj.tax_filters)) {
            obj.tax_filters[key].forEach((value, index ) => {
                console.log(key, value);
                const checkboxToCheck = $checkboxes_filter.filter(function (){
                    return $(this).val() === value && $(this).data('tax') === key;
                })
                checkboxToCheck.prop('checked', true);

                //redraw all active buttons filter
                const labelCheckbox = checkboxToCheck.next().html();
                add_active_filter_btn(key, value, labelCheckbox);
            })
        }
        show_hide_filter_box_and_link();
        ajax_data.current_page = obj.paginate;
    } else {
         // console.log("State n'existe pas");
        ajax_data.current_page             = 1;
        // uncheck all checkboxes
        $checkboxes_filter.prop("checked", false).blur();

        //remove all active buttons filter
        $( "#active_filter ul.active-filter-list li:not(#li-erase-all)").remove();
        show_hide_filter_box_and_link();
    }

    launch_ajax_query(ajax_data.current_page, true, true);

}

/**
 * Handler déclenché sur le bouton "Load More"
 * @param e
 */
const load_more_content = (e) => {
    e.preventDefault();

    // Define page number
    const new_page_number = parseInt(ajax_data.current_page) + 1;

    // Push history
    const historyData = build_history_data(new_page_number);
    history.pushState(historyData.stateData, '', historyData.url);

    launch_ajax_query(new_page_number, false);
}

/**
 * Handler déclenché au click sur les boutons de filtres (liste des taxonomies)
 * @param e
 */
const click_dropdown_filter_btn = (e) => {
    e.preventDefault();
    const $button = $(e.currentTarget),
        taxonomy_wrapper = $button.next(".filters-tax-terms-wrapper"),
        li_parent = $button.parent();

    if (li_parent.hasClass('dropdown-open')){
        //on click sue un bouton avec la liste dejà ouverte : on ferme
        li_parent.removeClass('dropdown-open');
        close_drop_down_filter(taxonomy_wrapper);

    }else{
        close_existing_dropdown_opened();
        li_parent.addClass('dropdown-open');
        gsap.set(taxonomy_wrapper, {display:'block',y:'30px', zIndex:70});
        gsap.to(taxonomy_wrapper, {opacity:1, y:'10px', duration:0.3, ease:"power1.out"})
    }
}

/**
 * Animation for closing dropdownfilter
 * @param taxonomy_wrapper
 */
const close_drop_down_filter = (taxonomy_wrapper) => {
    gsap.set(taxonomy_wrapper, {zIndex:66});
    gsap.to(taxonomy_wrapper, {opacity:0, ease:"power1.out", duration:0.3, y:'30px',onCompleteParams:[taxonomy_wrapper], onComplete:(el) => {
            gsap.set(el, {display:"none"})
        }})
}

/**
 * Close all dropdown filter opened
 */
const close_existing_dropdown_opened = () => {
    $filters_li.each(function() {
        if( $(this).hasClass("dropdown-open") ){
            $(this).removeClass("dropdown-open");
            const taxonomy_wrapper = $(this).children(".filters-tax-terms-wrapper");
            close_drop_down_filter(taxonomy_wrapper)
        }
    });
}

const build_history_data = (page_num) => {
    // Nouvel object URLSearchParams
    const searchParams = new URLSearchParams();
    // Ajout de la pagination dans l'url
    if(page_num > 1){
        searchParams.append(`paginate`, page_num);
    }

    const stateData = {
        paginate : page_num,
        tax_filters : {}
    };

    const $filters_checkboxes_active = $checkboxes_filter.filter(":checked")
    if( $filters_checkboxes_active.length ){
        $filters_checkboxes_active.each((index,element) => {
            const tax = $(element).data('tax');
            const slug = $(element).val();
            searchParams.append(`tax_filters[${tax}][]`, slug);
            if(!(tax in stateData.tax_filters)){
                stateData.tax_filters[tax] = [];
            }
            stateData.tax_filters[tax].push(slug);
        })
    }
    return {
        stateData,
        url : searchParams.toString() !== "" ? window.location.pathname + "?" + searchParams.toString() : window.location.pathname,
    }
}

const launch_ajax_query = (page_number = 1, refresh = true, display_previous = false) => {
    // build tax filters for the query
    const taxonomies_filters = get_filters();

    // Disable clik on button
    $filter_post.addClass("disable-btn");
    if(display_previous && page_number > 1){
        console.log("Je requete aussi les précédents !");
    }
    // Ajax query
    $.ajax({
        url: ajax_data.ajax_url,
        type: 'post',
        data: {
            action: define_action_nounce_name(ajax_data.post_type),
            nonce: ajax_data[get_nonce_name(ajax_data.post_type)],
            filters: taxonomies_filters,
            paged : page_number,                          // on click sur les filtres on demande la première page
            refresh : refresh,
        }
    })
        .done(function (res) {
            console.log(res);
            // if refresh, clear the content
            if(res.data.refresh){
                // clear content of the wrapper
                const $children = $rowWrapper.children();
                if($children.length){
                    gsap.to($children, {autoAlpha:0, duration:0,stagger: 0, ease:"power1.out", onComplete:() => $rowWrapper.empty() })
                }
            }


            // set global variable
            ajax_data.current_page             = res.data.current_page;
            ajax_data.posts_per_page           = res.data.posts_per_page;
            ajax_data.nb_total_pages           = res.data.nb_total_pages;
            ajax_data.display_more_post_button = res.data.display_more_post_button;

            // populate content
            if(res.data.refresh){
                $rowWrapper.html(res.data.html_data)
            }else{
                $rowWrapper.append(res.data.html_data)
            }
            // je dois écouter le chargement des nouvelles images des nouvelles cards que l'on vient de rajouter :
            const $cards_images = $rowWrapper.find('.card .card-image img'),
                  nb_new_cards = Object.keys(res.data.posts).length,
                    $last_images_added_after_ajax = $cards_images.slice(nb_new_cards * -1);

            $last_images_added_after_ajax.one("load", function() {
                $(window).trigger("resize");
            }).each(function() {
                if(this.complete) {
                    $(this).trigger('load');
                }
            });

            $(window).trigger("resize");
            init_animation();

            // Show or hide more button
            if(res.data.display_more_post_button){
                $rowMoreContent.removeClass("d-none");
            }else{
                $rowMoreContent.addClass("d-none");
            }
        })
        .fail(function (e) {
            console.error(e);
        })
        .always(function () {
            $filter_post.removeClass("disable-btn");
        });
}

/**
 * Build action nounce name
 * @param post_type_dashed_name
 * @returns {`ajax_get_${*}`}
 */
const define_action_nounce_name = (post_type_dashed_name) => {
    const regex = new RegExp('-', 'gm')
    const subst = `_`;
    const result = post_type_dashed_name.replace(regex, subst);
    return `ajax_get_${result}`;
}

const get_nonce_name = (post_type_dashed_name) => {
    const regex = new RegExp('-', 'gm')
    const subst = `_`;
    const result = post_type_dashed_name.replace(regex, subst);
    return `ajax_nounce_${result}`;
}

/**
 * Build the filters for the ajax query
 * @returns {{taxonomies_filters: *[], post_type: null}}
 */
const get_filters = () => {
    const $filters_checkboxes_active = $checkboxes_filter.filter(":checked");
    let taxonomies = {};
    $filters_checkboxes_active.each((index, el) => {
        // Check if current tax is already in array
        const taxName = $(el).data('tax');
        if (!(taxName in taxonomies)) {
            taxonomies[taxName] = [];
        }

        // Push the slug to the taxonomie[tax] array
        const slug = $(el).val();
        taxonomies[taxName].push(slug)
    });
    return taxonomies;
}

export {init_archive_page};
